<template>
  <b-modal title="Itens da Saída" v-model="show" size="xl">
    <div class="modal-screen-list">
      <!-- :::::::::::::::::::::::::::: TABELA DE ITENS :::::::::::::::::::::::::::: -->
      <b-table bordered hover small head-variant="light" :items="getSaidaItens" :fields="fields.saidaItem">
        <template #cell(acoes)="data">
          <div>
            <b-button class="pt-0 pb-0" variant="link" @click="editar(data.item)">
              <b-icon icon="pencil-square" variant="primary"> </b-icon>
            </b-button>
          </div>
        </template>
      </b-table>
    </div>
    <!-- :::::::::::::::::::::::::::: MODAIS DE USO :::::::::::::::::::::::::::: -->
    <item-edit-modal ref="saidaItemEdit" @update="update()" />
    <equipamento-list ref="equipamentoLista" />

    <template #modal-footer>
      <b-button class="pl-2 pr-3" variant="info" @click="adicionar()">
        <b-icon icon="plus-circle" variant="light" scale="1.1" class="mr-2" />Adicionar
      </b-button>
      <b-button class="pl-2 pr-3" variant="info" @click="equipamentos()">
        <b-icon icon="tools" variant="light" class="mr-2" />Equipamentos
      </b-button>
      <b-button variant="secondary" @click="show = !show">Fechar</b-button>
    </template>
  </b-modal>
</template>

<script>
import { useSgcqStore } from "@/stores/SgcqStore";
import { storeToRefs } from "pinia";
import { useEntradaSaidaStore } from "@/stores/EntradaSaidaStore";
import TableFields from "@/tools/TableFields";
import Saida from "@/models/Saida";
import SaidaItem from "@/models/SaidaItem";
import SaidaItensEditModal from "@/components/modals/armazem/SaidaItensEditModal";
import EquipamentoListModal from "@/components/modals/equipamento/EquipamentoListModal";

export default {
  name: "SaidaItensListModal",

  components: {
    "item-edit-modal": SaidaItensEditModal,
    "equipamento-list": EquipamentoListModal,
  },

  data() {
    return {
      show: false,
      fields: new TableFields(),
      saida: new Saida(0, "Nova Entrada", "", new Date(), "", "", "", ""),
      itens: [],
      item: new SaidaItem(0, "", "Novo Item", 0),
    };
  },

  methods: {
    editar(item) {
      item.saida = this.saida;
      this.$refs.saidaItemEdit.call(item);
    },

    adicionar() {
      let item = new SaidaItem(0, "", "Novo Item", 0);
      item.saida = this.saida;
      this.$refs.saidaItemEdit.call(item);
    },

    equipamentos() {
      this.$refs.equipamentoLista.call();
    },

    executar() {
      this.entradaSaidaStore.REMOVER_SAIDA_ITEM(this.item.id).then(() => {
        this.update();
      });
    },

    update() {
      this.entradaSaidaStore.LISTAR_SAIDA_ITENS(this.saida.id).then(() => {
        this.item = new SaidaItem(0, "", "Novo Item", 0);
        this.itens = this.getSaidaItens;
      });
    },

    call(saida) {
      this.show = !this.show;
      this.saida = saida;
      this.update();
    },
  },

  setup() {
    const store = useSgcqStore();
    const entradaSaidaStore = useEntradaSaidaStore();
    const { getSaidaItens } = storeToRefs(entradaSaidaStore);

    return {
      store,
      entradaSaidaStore,
      getSaidaItens,
    };
  },
};
</script>

<style lang="scss" scoped></style>
